import React from 'react'
import { Modal } from 'react-bootstrap';

function VideoModal({link="", open, setOpen, title="Video"}) {
  
  return (
        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={open}
          
          // onBackdropClick={() => setOpen(false)}
        >
          <Modal.Header closeButton={true} onHide={() => setOpen(false)}>
            <Modal.Title id="contained-modal-title-vcenter">
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='videoModalBody'>
            {/* <source src={link} type="video/mp4" height={400} width={200} /> */}
            <video controls width="100%" autoPlay={true}>
              <source src={link} type="video/mp4" />
              Sorry, your browser doesn't support embedded videos.
            </video>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
          </Modal.Footer> */}
        </Modal>
      );
    
}

export default VideoModal